/**
 * ``useTracksLayerVisible`` — the Profile's ``map.visible_layers.tracks``
 * flag (ADR-041; REQ-UI-173), read the way the geometry layers read theirs
 * (:func:`map/use-geometry-layers.useGeometryProfileDefaults`): straight off
 * :data:`PreferencesContext`, non-throwing.
 *
 * No provider (bare unit tests) or an older Profile that predates the flag
 * ⇒ ``true`` — the schema default. A track layer that silently hid itself
 * would be a fail-open on the operator's picture (CLAUDE.md §8.1), so absence
 * shows, never hides.
 */
import { useContext } from "react";
import { PreferencesContext } from "@/preferences/preferences-context";

export function useTracksLayerVisible(): boolean {
  const ctx = useContext(PreferencesContext);
  return ctx?.workingState.map?.visible_layers?.tracks ?? true;
}
